<img [style.width.%]="this.defaultWidth" src="../../../../../assets/images/spinner.svg" [hidden]="!showSpinner">
